import { root } from '../../../../store/constants';

export const isContinuedReadOnly = () => {
    return Boolean(root.App.controller && root.App.controller.allowReadOnly);
};
